import { Button } from "@mui/material";

import { useNavigate } from "react-router";

const JoinNowButton = () => {
  const navigate = useNavigate();
  console.log("react app node env", process.env.REACT_APP_NODE_ENV);
  const isProduction = process.env.REACT_APP_NODE_ENV === "production";
  //   const content2 = (
  //     <Button
  //             component={'a'}
  //             href={'/enroll'}
  //             variant="contained"
  //             color="primary"
  //             size="large"
  //             endIcon={
  //               <svg
  //                 width={16}
  //                 height={16}
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 fill="none"
  //                 viewBox="0 0 24 24"
  //                 stroke="currentColor"
  //               >
  //                 <path
  //                   strokeLinecap="round"
  //                   strokeLinejoin="round"
  //                   strokeWidth={2}
  //                   d="M17 8l4 4m0 0l-4 4m4-4H3"
  //                 />
  //               </svg>
  //             }
  //           >
  //             Join Now
  //           </Button>
  //   );

  const buttonContent = (
    <Button
      color="primary"
      className="button1"
      variant="contained"
      style={{
        width: "10rem",
        borderRadius: "1.25rem",
        fontFamily: "Arial",
      }}
      disabled={isProduction}
      onClick={() => {
        if (!isProduction) {
            navigate("/sign-up");
        }
        
      }}
    >
      {isProduction ? "Coming Soon" : "Join Now"}
    </Button>
  );

  return buttonContent;
};

export default JoinNowButton;
